<div class="container-fluid w-100 h-100 {{ this._style }}-main-panel">
  <h3>Under construction!</h3>
</div>
